/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card } from "@mui/material";
import FairData from "layouts/tables/data/fairTableData";
import { useEffect, useState } from "react";

function Fair() {
  const { sales, tasks } = reportsLineChartData;

  const [list, setList] = useState([]);

  // const FairLists = () => {
  //   return (
  //     <MDBox p={0}>
  //       <FairData></FairData>
  //     </MDBox>
  //   );
  // };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Fair" />
      <MDBox py={3}>
        {/* <FairLists /> */}
        <FairData></FairData>
      </MDBox>
      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default Fair;
